module.exports = __webpack_public_path__ + "static/media/jt3.6aab0b4e.png";